
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-help",
      function () {
        return require("private-next-pages/get-help.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-help"])
      });
    }
  